export const initCSSMarquee = () => {

	const pixelsPerSecond = 20;
	const marquees = document.querySelectorAll('[data-css-marquee]');

	// Duplicate each [data-css-marquee-list] element inside its container
	marquees.forEach(marquee => {
		marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
			const duplicate = list.cloneNode(true)
			marquee.appendChild(duplicate)
		})
	})

	// Create an IntersectionObserver to check if the marquee container is in view
	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			entry.target.querySelectorAll('[data-css-marquee-list]').forEach(list =>
				list.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused'
			)
		}) 
	}, { threshold: 0 })

	// Calculate the width and set the animation duration accordingly
	marquees.forEach(marquee => {
		marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
			list.style.animationDuration = (list.offsetWidth / pixelsPerSecond) + 's'
			list.style.animationPlayState = 'paused'
		})
		observer.observe(marquee)

		marquee.addEventListener('mouseenter', () => {
			marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
				list.style.animationPlayState = 'paused'
			})
		})

		marquee.addEventListener('mouseleave', () => {
			marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
				list.style.animationPlayState = 'running'
			})
		})
	})
}

export default () => {}